'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/components/modal-anchor.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _reactRedux = require('react-redux');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _selectors = require('../selectors');
var selectors = _interopRequireWildcard(_selectors);
var _reactRouterDom = require('react-router-dom');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var anchorStyles = function anchorStyles(_ref) {
  var active = _ref.active,
    top = _ref.top;
  return active ? {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    top: top
  } : {};
};
var Anchor = _glamorous2.default.div(anchorStyles);
var ModalAnchor = function (_Component) {
  _inherits(ModalAnchor, _Component);
  function ModalAnchor() {
    _classCallCheck(this, ModalAnchor);
    return _possibleConstructorReturn(this, (ModalAnchor.__proto__ || Object.getPrototypeOf(ModalAnchor)).apply(this, arguments));
  }
  _createClass(ModalAnchor, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.top) {
        window.scrollTo(window.scrollX, this.props.top);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
        top = _props.top,
        active = _props.active,
        children = _props.children;
      return _react2.default.createElement(Anchor, {
        top: -top,
        active: active,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 35
        },
        __self: this
      }, children);
    }
  }]);
  return ModalAnchor;
}(_react.Component);
ModalAnchor.propTypes = {
  active: _propTypes.bool.isRequired,
  children: _propTypes.node.isRequired,
  top: _propTypes.number
};
exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(function (state) {
  return {
    active: selectors.modalActive(state),
    top: selectors.scrollY(state)
  };
})(ModalAnchor));